import LandingPageComponent from "./components/LandingPageComponent";
import { useSelector } from "react-redux";
import axios from "axios";

const getBestsellers = async () => {
    const { data } = await axios.get("/api/products/bestsellers");
    return data;
}

const HomePage = () => {

    const { categories } = useSelector((state) => state.getCategories);

  return <LandingPageComponent categories={categories} getBestsellers={getBestsellers} />;
};

export default HomePage;
